<template>
  <a-form
      ref="userFormRef"
      :model="formData"
      name="basic"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }"
      class="settings-form"
  >
<!--    <a-form-item label="手机号码" name="phonenumber">-->
<!--      <a-input v-model:value="formData.phonenumber" placeholder="请输入" readonly />-->
<!--    </a-form-item>-->
    <a-form-item label="用户昵称" name="nickName">
      <a-input v-model:value="formData.nickName" placeholder="请输入" />
    </a-form-item>
    <a-form-item label="用户邮箱" name="email">
      <a-input v-model:value="formData.email" placeholder="请输入" />
    </a-form-item>
    <a-form-item label="性别" name="sex">
      <a-radio-group v-model:value="formData.sex">
        <a-radio :value="'0'">男</a-radio>
        <a-radio :value="'1'">女</a-radio>
      </a-radio-group>
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 12, offset: 6 }">
      <a-button type="primary" @click="handleSave">保存</a-button>
      <a-button style="margin-left: 10px" @click="handleClose">关闭</a-button>
    </a-form-item>
  </a-form>
</template>

<script setup>
import { ref, reactive, defineProps, defineEmits, watch } from "vue";
import { message } from "ant-design-vue";
import { useRouter } from 'vue-router'
import { updateUserProfile } from '@/api/system/user';
const router = useRouter();

const props = defineProps({
  user: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(['update:userInfo']);

const userFormRef = ref();
const formData = reactive({});

const rules = ref({
  nickName: [{ required: true, message: "用户昵称不能为空", trigger: "blur" }],
  phonenumber: [{ required: true, message: "手机号码不能为空", trigger: "blur" }, { pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/, message: "请输入正确的手机号码", trigger: "blur" }],
});

// 保存基本信息
const handleSave = () => {
  userFormRef.value.validate().then(() => {
    // 这里调用API保存基本信息
    updateUserProfile(formData).then(response => {
      message.success('基本信息保存成功');
      // 触发事件，更新父组件中的用户信息
      emit('update:userInfo', formData);
    });
  }).catch(error => {
    console.log('表单验证失败:', error);
  });
};

const handleClose = () => {
  router.back()
}

// 监听用户信息变化，更新表单数据
watch(() => props.user, (newUserInfo) => {
  if (newUserInfo) {
    Object.assign(formData, {
      userId: newUserInfo.userId,
      nickName: newUserInfo.nickName,
      phonenumber: newUserInfo.phonenumber,
      email: newUserInfo.email,
      sex: newUserInfo.sex
    });
  }
}, { immediate: true, deep: true });
</script>

<style lang="less" scoped>
.settings-form {
  .ant-form-item {
    margin-bottom: 24px;
  }

  .ant-form-item-label > label {
    font-size: 16px !important;
    font-weight: 600 !important;
    color: #1d2129 !important;
  }

  .ant-radio-wrapper {
    margin-right: 16px;
  }

  .ant-input,
  .ant-input-password,
  .ant-select-selector {
    width: 50% !important;
  }
}
</style>